import React from 'react';
import { ClipboardList, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'context/StoreContext';
import { useApi } from 'hooks/useApi';
import { CostDocumentService } from 'services/costs/cost-document.service';
import { LoadingScreen } from 'components/common/Spinner';
import { Button } from 'components/common/Button';
import { formatDateTime } from 'utils/formatters';

export default function PendingReviewsPage() {
  const { org, currentStore } = useStore();
  const navigate = useNavigate();
  const { data: documents, loading } = useApi(
    () => CostDocumentService.listPending(org?.id ?? '', currentStore?.id ?? ''),
    [org?.id, currentStore?.id]
  );
  if (loading) return <LoadingScreen />;
  return <div className="space-y-5">
    <div className="flex items-center gap-2"><ClipboardList size={20} className="text-gray-600" /><h1 className="text-xl font-bold text-gray-900">Receipt Attention</h1></div>
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      {!documents?.length ? <div className="p-8 text-center text-sm text-gray-500">No receipt reviews are waiting.</div> : documents.map(document => <button key={document.id} type="button" onClick={() => navigate(document.status === 'PROCESSING' || document.status === 'FAILED' ? `/costs/processing/${document.id}` : `/costs/review/${document.id}`)} className="flex w-full items-center gap-4 border-b border-gray-100 px-4 py-4 text-left last:border-0 hover:bg-gray-50"><div className="flex-1"><p className="text-sm font-medium text-gray-900">{document.document_type} from {document.source_type}</p><p className="mt-1 text-xs text-gray-500">{formatDateTime(document.created_at)} · {document.status}</p></div><ChevronRight size={16} className="text-gray-400" /></button>)}
    </div>
    <Button variant="secondary" onClick={() => navigate('/costs')}>Back to Costs</Button>
  </div>;
}
